"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectActiveView = selectActiveView;
function selectActiveView(state) {
  return state.view.active;
}